import Icon from '@mui/icons-material/Feed'

export default {
  name: 'events',
  icon: Icon,
  options: {
    defaultSort: { field: 'date', order: 'DESC' },
  },
}
